import { SubMenuList } from '../sub-menu-list';

export class ReportsListButton extends SubMenuList {
  name = 'reports-list';
}
